<template>
  <div class="pt-[3.75rem] text-left">
    <h3 class="co-display-7 mb-4 text-center font-bold">
      仕事の紹介実例
    </h3>
    <h4 class="co-display-12 mb-8 text-center leading-relaxed">
      年間で
      <span class="co-display-10 font-bold">1,000</span>
      <span class="font-bold">件以上</span>
      の案件を納品
      <br>
      多数の案件からあなたにあった仕事を紹介します。
    </h4>
    <div class="co-container-lg mx-auto mb-8">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="1"
        :space-between="32"
        :breakpoints="{
          '768': {
            slidesPerView: 2,
          },
          '992': {
            slidesPerView: 3,
          },
        }"
        :pagination="{
          clickable: true,
        }"
        class="!px-px"
      >
        <SwiperSlide
          :key="1"
          class="!h-auto"
        >
          <div class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5">
            <p class="co-display-11 text-center font-bold">
              エネルギー系企業
              <br>
              Webページ制作
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  HTML/CSSコーディング
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  4~5万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="2"
          class="!h-auto"
        >
          <div class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5">
            <p class="co-display-11 text-center font-bold">
              大手建築企業
              <br>
              Webページ制作
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  HTML/CSSコーディング
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  3~4万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="3"
          class="!h-auto"
        >
          <div class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5">
            <p class="co-display-11 text-center font-bold">
              大手ITサービス
              <br>
              Webページ制作
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  HTML/CSSコーディング
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  1~2万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="4"
          class="!h-auto"
        >
          <div class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5">
            <p class="co-display-11 text-center font-bold">
              大手美容サービス
              <br>
              Webページ制作
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  HTML/CSSコーディング
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  ~1万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="5"
          class="!h-auto"
        >
          <div class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5">
            <p class="co-display-11 text-center font-bold">
              フラワーショップ
              <br>
              Webページ制作
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  HTML/CSSコーディング
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  3~4万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="6"
          class="!h-auto"
        >
          <div class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5">
            <p class="co-display-11 text-center font-bold">
              大手食品会社
              <br>
              Webページ制作
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  HTML/CSSコーディング
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  1~2万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="7"
          class="!h-auto"
        >
          <div class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5">
            <p class="co-display-11 text-center font-bold">
              大手通信サービス
              <br>
              Webページ制作
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  HTML/CSSコーディング
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  1~2万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="8"
          class="!h-auto"
        >
          <div class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5">
            <p class="co-display-11 text-center font-bold">
              スポーツショップ
              <br>
              Webページ制作
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  HTML/CSSコーディング
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  1~2万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <!-- Works用のスライド -->
        <SwiperSlide
          v-if="works"
          :key="9"
          class="!h-auto"
        >
          <div
            class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5"
          >
            <p class="co-display-11 text-center font-bold">
              大手洗剤メーカー
              <br>
              画像デザイン
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  ECサイト用画像制作
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  1~2万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          v-if="works"
          :key="10"
          class="!h-auto"
        >
          <div

            class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5"
          >
            <p class="co-display-11 text-center font-bold">
              大手海外食品メーカー
              <br>
              画像デザイン
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  バナー制作
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  1~2万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          v-if="works"
          :key="11"
          class="!h-auto"
        >
          <div
            class="te-slider-work-example-slide mb-1 h-full bg-co-gray-50 px-4 pb-4 pt-5 shadow md:px-5 md:pb-5"
          >
            <p class="co-display-11 text-center font-bold">
              大手洗剤メーカー
              <br>
              画像デザイン
            </p>
            <div class="te-slider-work-example-content mx-auto">
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  内容
                </span>
                <span class="co-display-13">
                  バナー制作
                </span>
              </div>
              <div class="mb-3 flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  サポート
                </span>
                <span class="co-display-13">
                  メンターサポートあり
                </span>
              </div>
              <div class="flex items-baseline">
                <span class="te-badge mr-2 px-0 py-1 text-center font-normal md:mr-3">
                  報酬
                </span>
                <span class="te-reward co-display-13 font-bold text-co-primary-500">
                  ~1万
                  <span class="text-base">円</span>
                </span>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <span class="co-display-14 mb-6 block text-co-gray-500">
      ※契約上の理由により一部内容を加工してあります。
    </span>
    <p class="te-work-example-notes co-display-13 mx-auto mb-0 px-6 py-3">
      上記はメンターサポートが付いた場合の金額です。
      <br>
      メンターサポートを付けずに対応できるようになると
      <br>
      <span class="co-display-11 font-bold text-co-primary-500">
        報酬額が約1.6倍</span><span class="text-co-primary-500">※</span>に上がります。
      <br>
      <span class="co-display-14 text-co-gray-500">
        ※仕事の状況によって変動する場合がございます。
      </span>
    </p>
  </div>
</template>

<script lang="ts">

const options = {
  props: {
    works: { // works用スライドの表示切り替え
      type: Boolean,
      default: false,
    },
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
@import url('~/assets/css/Te/TeCommon/TeCommonSwiper.css');

.te-slider-work-example-slide {
  border-top: 6px solid #61a7b7;
}

.te-slider-work-example-content {
  @media (max-width: 991.98px) {
    max-width: 15rem;
  }
}

.te-badge {
  display: inline-block;
  width: 4.25rem;
  font-size: 75%;
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
  background-color: #f2f2f2;
  border-radius: 0.625rem;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  @media (min-width: 992px) {
    width: 4.375rem;
  }
}

.te-reward {
  font-size: 1.375rem;
}

/* カルーセル下のボックス */
.te-work-example-notes {
  max-width: 21.437rem;
  border: 1px solid #61a7b7;
  @media (min-width: 992px) {
    max-width: 24.125rem;
  }
}
</style>
